define('Components/VoucherSMSWidget/js/views/VoucherSMSWidgetView',['jquery','WidgetInstanceView',
        'template!Components/VoucherSMSWidget/templates/default'
    ],
    function($,WidgetInstanceView,
             defaultTemplate
    ){
    return WidgetInstanceView.extend({
        name:'TitleWidgetInstanceView',
        getTemplate:function(){
            return defaultTemplate;
        },
    })
});
